<template>
  <slide-panel title="Menu" @panelclose="closeMenu">
    <div class="hr mb-3"></div>
    <div
      class="profile-section justify-content-between d-flex"
      @click="goToProfile()"
    ></div>

    <ul class="menu-items mt-3">
      <li class="el-menu-item" @click="closeMenu">
        <router-link :to="{ name: 'Feed', params: { isActiveFilter: 1 } }">
          Feed
        </router-link>
      </li>
      <!--li
        class="el-menu-item"
        @click="closeMenu"
      >
        <router-link :to="{ name: 'About Network' }">
          About Network
        </router-link>
      </!--li-->
      <!--li
        class="el-menu-item"
        @click="closeMenu"
      >
        <router-link :to="{ name: 'Become a Service' }">
          Become a Service
        </router-link>
      </!--li-->
      <!--li
        class="el-menu-item"
        @click="closeMenu"
      >
        <router-link :to="{ name: 'About' }">
          About our organisation
        </router-link>
      </!--li-->
      <!--li
        class="el-menu-item"
        @click="closeMenu"
      >
        <router-link :to="{ name: 'Case Studies Public' }">
          Case studies
        </router-link>
      </!--li-->

      <!--li
        class="el-menu-item"
        @click="closeMenu"
      >
        <router-link :to="{ name: 'Business Events Webinars' }">
          Events
        </router-link>
      </!--li-->

      <!--li
        class="el-menu-item"
        @click="closeMenu"
      >
        <a
          :href="getBeWellPageUrl('/for-my-organisation/contact-us-cwb')"
          target="_blank"
        >
          Contact us
        </a>
      </!--li-->
    </ul>

    <div class="hr mt-3 mb-3"></div>

    <ul class="menu-links">
      <li @click="closeMenu">
        <router-link
          v-if="
            !user.isLogged &&
            !userRequiresVerification &&
            $route.path !== '/sign-up-select' &&
            $route.name !== 'NotFound' &&
            $route.name !== 'Reset Password'
          "
          class="el-button el-button--primary el-button--medium"
          to="/sign-up-select"
          tabindex="0"
        >
          Join the network
        </router-link>
      </li>
      <li class="text-center" @click="closeMenu">
        <a
          v-if="
            !user.isLogged &&
            !userRequiresVerification &&
            $route.path !== '/sign-up-select' &&
            $route.name !== 'NotFound' &&
            $route.name !== 'Reset Password'
          "
          :href="getBeWellPageUrl('/for-my-organisation')"
          class="mt-3"
          >Back to Community Wealth Builder</a
        >
      </li>
      <li @click="closeMenu">
        <router-link
          v-if="
            !user.isLogged &&
            !userRequiresVerification &&
            $route.path !== '/login' &&
            $route.name !== 'NotFound' &&
            $route.name !== 'Reset Password'
          "
          class="el-button el-button--medium"
          to="/login"
          tabindex="0"
        >
          Log in
        </router-link>
      </li>
      <li @click="closeMenu">
        <el-button
          v-if="
            (user.isLogged || userRequiresVerification) &&
            $route.name !== 'Reset Password'
          "
          class="el-button el-button--medium"
          tabindex="0"
          @click="logout($event)"
        >
          Logout
        </el-button>
      </li>
    </ul>
  </slide-panel>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import SlidePanel from "@/components/slide-panel/slide-panel";

export default {
  name: "MobileMenu",
  components: {
    "slide-panel": SlidePanel,
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["userRequiresVerification"]),
    getBeWellPageUrl() {
      return (page) => {
        return `${process.env.VUE_APP_BE_WELL_CMS_URL}${page}`;
      };
    },
  },
  methods: {
    goToProfile() {
      this.closeMenu();
      this.$router.push({
        name: "Member Profile",
        params: { id: this.user.id },
      });
    },
    closeMenu() {
      this.$emit("close");
    },
  },
};
</script>
